import { BookMarked, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { generatePath, Link } from "react-router-dom";
import routing from "routing";
import { IconButton, TextButton } from "src/components/Default/LekUI/Button";
import { hasLimitedAccess } from "src/helpers/getPermissions";
import useLocalStorage from "src/hooks/useLocalStorage";

export const GuideBanner = () => {
	const { t } = useTranslation();
	// ponytail: dismissal kept per browser in localStorage; move to a user flag on the backend if it must follow the account
	const [isDismissed, setIsDismissed] = useLocalStorage(
		"guideBannerDismissed",
		false,
	);

	if (isDismissed || hasLimitedAccess()) {
		return null;
	}

	return (
		<div className="promo-banner-container">
			<div className="promo-banner" data-test-id="guide-banner">
				<BookMarked className="promo-banner--icon" />
				<div className="promo-banner--text">
					<span className="promo-banner--title">
						{t("guide.banner.title", "Nie wiesz od czego zacząć naukę?")}
					</span>
					<span className="promo-banner--subtitle">
						{t(
							"guide.banner.subtitle",
							"Sprawdź nasz poradnik i przygotuj się do egzaminu według sprawdzonego schematu",
						)}
					</span>
				</div>
				<TextButton
					component={Link}
					to={generatePath(routing.paths.guide)}
					className="promo-banner--action"
					data-test-id="guide-banner-link"
				>
					{t("guide.banner.action", "Zobacz poradnik")}
				</TextButton>
				<IconButton
					size="small"
					disableRipple
					className="promo-banner--close"
					onClick={() => setIsDismissed(true)}
					aria-label={t("commands.close", "Zamknij")}
					data-test-id="guide-banner-close"
				>
					<X className="icon-tiny" />
				</IconButton>
			</div>
		</div>
	);
};
